<h1 mat-dialog-title>Find Induction Attendee</h1>


<div mat-dialog-content style="display: flex;flex-direction: column;">

  <div *ngIf="loading == true" style="display: flex;flex-direction: row;flex:1;align-items: center;justify-content: center;">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="loading == false && (!FindAttendeeResult || FindAttendeeResult.length==0)">

  <div style="display:flex;flex-direction:row;justify-content: space-between;">
    <div class="example-full-width" style="width: 500px;display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;min-width: 120px;">First Name</mat-label>
      <input style="width: 500px;" type="text" matInput placeholder="First Name" [(ngModel)]="fName" class="get-Input">
    </div>

    <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;margin-left: 1%;">
    <mat-label style="font-weight: bold;min-width: 120px;">Last Name</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Last Name" [(ngModel)]="lName" class="get-Input">
  </div>
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;min-width: 120px;">Email Address</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Email Address" [(ngModel)]="EmailAddress" class="get-Input">
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;min-width: 120px;">Company</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Company" [(ngModel)]="Company" class="get-Input">
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;min-width: 120px;">Position</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Position" [(ngModel)]="Position" class="get-Input">
  </div>


</div>

  <div *ngIf="loading== false && (FindAttendeeResult &&FindAttendeeResult.length>0)" style="display: flex;flex-direction: column;">
  
    <div style="display: flex;flex-direction: row;justify-content: space-between;margin-left: 20px;">
      <span style="font-weight: bold;display: flex ;flex:1;align-items: center;justify-content: left;"> Name </span>
      <span style="font-weight: bold;display: flex;flex:0.5;align-items: center;justify-content: left;"> Position </span>
      <span style="font-weight: bold;display: flex;flex:0.5;align-items: center;justify-content: left;"> Company </span>
      <span style="font-weight: bold;display: flex;flex:1;align-items: center;justify-content: left;"> Email </span>
      <span style="font-weight: bold;display: flex;flex:0.5;align-items: center;justify-content: left;">  </span>
    </div>

    <mat-list role="list" *ngFor="let ques of FindAttendeeResult">
        <mat-list-item role="listitem">
          <div style="display: flex;flex-direction: row;justify-content: space-between;flex:1">
            <span style="display: flex;flex:1;align-items: center;justify-content: left;"> {{ques.Fname}} {{ques.Lname}} </span>
            <span style="display: flex;flex:0.5;align-items: center;justify-content: left;"> {{ques.Position}} </span>
            <span style="display: flex;flex:0.5;align-items: center;justify-content: left;"> {{ques.Company}} </span>
            <span style="display: flex;flex:1;align-items: center;justify-content: left;"> {{ques.Email}} </span>
            <div style="display: flex;flex-direction: row;flex:0.5">
              <a style="display: flex;margin-left: 20px;" 
              class="button button--primary" 
              style="min-width: 0px;" (click)="ClickAddInductionAttendee(ques)">
                <i style="margin-left: 14%;" class="material-icons button__icon" *ngIf="ques.check != true">add</i>
                <i style="margin-left: 14%;" class="material-icons button__icon" *ngIf="ques.check == true">done</i>

              </a>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
  
  </div>

</div>
<div mat-dialog-actions class="dialogControllBtn">
  <a class="button" style="margin-left: 20px;" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
  <a class="button button--primary" style="margin-left: 20px;" *ngIf="!FindAttendeeResult || FindAttendeeResult.length==0" (click)="onSubmitClick()"><span class="button__text">Search</span></a>
  <a class="button button--primary" style="margin-left: 20px;" *ngIf="FindAttendeeResult &&FindAttendeeResult.length>0" (click)="onDoneClick()"><span class="button__text">Done</span></a>


</div>